import React from 'react';
import { connect } from 'react-redux';
import { Control, Fieldset, actions } from 'react-redux-form';
import {
  investmentInfoPath,
} from './Schemas/baseRrf';
import CheckOption from '../Invest/components/CheckOption';
import InputField from './Controls/Field';
import { validateTickerChars } from './Validators';

import './styles.css';


const getFields = (isFinra, isDirector, dispatch, disclosuresPath) => ([
  {
    model: '.directorOrTenPercentShareholder',
    RRFComp: Control.checkbox,
    checkLabel: 'Are you an officer/board member or 10% holder of a public company?',
    control: {
      onChange: () => dispatch(actions.reset(`${investmentInfoPath}${disclosuresPath}.directorOrTenPercentShareholderCompany`)),
      isToggle: true,
      component: CheckOption,
      checked: false,
    },
  }, {
    model: '.directorOrTenPercentShareholderCompany',
    RRFComp: Control.text,
    control: {
      placeholder: 'Company Ticker Symbols',
      errors: {
        required: val => isDirector && (!val || !val.length),
        chars: val => val && !validateTickerChars(val),
      },
    },
    error: {
      messages: {
        required: 'Please provide the Company Ticker Symbols.',
        chars: 'Ticker Symbols may include letters, numbers, and periods, separated by a comma.',
      },
    },
  }, {
    model: '.finraAffiliated',
    RRFComp: Control.checkbox,
    checkLabel: 'Do you work for a FINRA member firm or an exchange?',
    control: {
      onChange: () => dispatch(actions.reset(`${investmentInfoPath}${disclosuresPath}.finraCompany`)),
      isToggle: true,
      component: CheckOption,
      checked: false,
    },
  }, {
    model: '.finraCompany',
    RRFComp: Control.text,
    control: {
      placeholder: 'Name of the FINRA Company',
      maxLength: 45,
      errors: {
        required: val => isFinra && (!val || !val.length),
      },
    },
    error: {
      messages: {
        required: 'Please provide the Name of the FINRA Company.',
      },
    },
  },
]);

const Disclosures = ({
  disclosuresPath,
  isFinra,
  isDirector,
  dispatch,
}) => {
  const fields = getFields(isFinra, isDirector, dispatch, disclosuresPath);

  return (
    <Fieldset model={disclosuresPath}>
      <InputField
        id={fields[0].model}
        fieldProps={fields[0]}
        key={fields[0].model}
      >
        {fields[0].checkLabel}
      </InputField>
      {isDirector ?
        <InputField key={fields[1].model} fieldProps={fields[1]} />
      : null}
      <InputField
        id={fields[2].model}
        fieldProps={fields[2]}
        key={fields[2].model}
      >
        {fields[2].checkLabel}
      </InputField>
      {isFinra ?
        <InputField key={fields[3].model} fieldProps={fields[3]} />
      : null}
    </Fieldset>
  );
};

export default connect(null, null)(Disclosures);




// WEBPACK FOOTER //
// ./src/components/Forms/Disclosures.js